import React from "react";
import { Link } from "react-router-dom";
const Cta = ({
  children,
  className = "",
  type = "button",
  variant = "default",
  href = "",
  target = "_self",
}) => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const variants = {
    default:
      "bg-custom-blue-v2 text-custom-white-v2 hover:border-custom-blue-v2 hover:bg-transparent hover:text-custom-blue-v2 shadow hover:shadow-custom-blue-v2 border-transparent hover:bg-white/30",
    outline:
      "border-white text-custom-white-v2 hover:border-custom-blue-v2 shadow hover:shadow-custom-blue-v2 hover:text-custom-blue-v2 hover:bg-white",
  };
  return !href ? (
    <button
      type={type}
      className={`${className} py-3 px-6 rounded-full text-lg font-medium !leading-[130%] border border-solid hover:backdrop-blur-sm ${variants[variant]}`}>
      {children || "Get A Quote"}
    </button>
  ) : (
    <Link
      onClick={scrollToTop}
      to={href}
      target={target}
      className={`${className} py-3 px-6 rounded-full text-lg font-medium !leading-[130%] border border-solid hover:backdrop-blur-sm inline-block ${variants[variant]}`}>
      {children || "Get A Quote"}
    </Link>
  );
};

export default Cta;
